import { sendOTPApi } from 'entities/sendOTP/model';
import { HTTP_METHODS } from 'shared/consts';
import { toast } from 'react-toastify';

const deleteOTPApi = sendOTPApi.injectEndpoints({
  endpoints: (builder) => ({
    deleteOTP: builder.mutation({
      query: ({ id }) => ({
        url: `/callpassword/admin/methodprioritys/${id}`,
        method: HTTP_METHODS.DELETE,
      }),
      invalidatesTags: (result, error) => {
        const error_message = error?.status;
        if (error) {
          toast.error(error_message, {
            position: toast.POSITION.TOP_RIGHT,
          });
        } else {
          toast.success('Вы успешно удалили способ отправки', {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
        return [{ type: 'SendOTP' }];
      },
    }),
  }),
});

export const { useDeleteOTPMutation } = deleteOTPApi;
